import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const ResetPasswordPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [validating, setValidating] = useState(true);
  const [tokenError, setTokenError] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (!token) {
      setTokenError(t('adminLogin.resetMissingToken'));
      setValidating(false);
      return;
    }
    axios
      .get('/api/auth/reset-password/validate', { params: { token } })
      .then(() => setTokenError(''))
      .catch((err) => {
        setTokenError(err.response?.data?.error || t('adminLogin.resetInvalidToken'));
      })
      .finally(() => setValidating(false));
  }, [token, t]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) {
      setError(t('adminLogin.resetPasswordShort'));
      return;
    }
    if (password !== passwordConfirm) {
      setError(t('adminLogin.resetPasswordMismatch'));
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post('/api/auth/reset-password', { token, password });
      setSuccess(res.data.message || t('adminLogin.resetSuccess'));
      setTimeout(() => navigate('/admin/login', { replace: true }), 2500);
    } catch (err) {
      setError(err.response?.data?.error || t('adminLogin.resetError'));
    } finally {
      setLoading(false);
    }
  };

  if (validating) {
    return (
      <div className="container">
        <div className="card admin-auth-card">
          <p>{t('adminLogin.resetValidating')}</p>
        </div>
      </div>
    );
  }

  if (tokenError) {
    return (
      <div className="container">
        <div className="card admin-auth-card">
          <h2>{t('adminLogin.resetTitle')}</h2>
          <div className="error">{tokenError}</div>
          <p className="admin-auth-back">
            <Link to="/admin/forgot-password">{t('adminLogin.forgotLink')}</Link>
            {' · '}
            <Link to="/admin/login">{t('adminLogin.backToLogin')}</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="card admin-auth-card">
        <h2>{t('adminLogin.resetTitle')}</h2>
        <p className="section-desc">{t('adminLogin.resetLead')}</p>
        {error && <div className="error">{error}</div>}
        {success && <div className="success">{success}</div>}
        {!success && (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>{t('adminLogin.resetNewPassword')}</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                disabled={loading}
                autoComplete="new-password"
              />
            </div>
            <div className="form-group">
              <label>{t('adminLogin.resetConfirmPassword')}</label>
              <input
                type="password"
                value={passwordConfirm}
                onChange={(e) => setPasswordConfirm(e.target.value)}
                required
                minLength={6}
                disabled={loading}
                autoComplete="new-password"
              />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
              {loading ? t('adminLogin.resetSaving') : t('adminLogin.resetSubmit')}
            </button>
          </form>
        )}
        <p className="admin-auth-back">
          <Link to="/admin/login">{t('adminLogin.backToLogin')}</Link>
        </p>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
